<template>
  <div>
    <validation-observer ref="awaitTillDateRules">
      <b-form>
        <b-row>
          <b-col sm="12">
            <b-form-group
              label="Question"
              label-for="await-till-date-question"
            >
              <validation-provider
                #default="{ errors }"
                name="Question"
                vid="Question"
                rules="required"
              >
                <b-form-input
                  id="await-till-date-question"
                  v-model="question"
                  :placeholder="$t('DEBTIA_ENTER_QUESTION')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Description"
              label-for="await-till-date-description"
            >
              <validation-provider
                #default="{ errors }"
                name="Description"
                vid="Description"
                rules="required"
              >
                <b-form-input
                  id="await-till-date-description"
                  v-model="description"
                  :placeholder="$t('DEBTIA_ENTER_DESCRIPTION')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="submitForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      question: '',
      description: '',
      required,
      errorMessage: '',
    }
  },
  methods: {
    submitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 24,
        module_order: 1,
        question: this.question,
        description: this.description,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      this.$refs.awaitTillDateRules.validate().then(success => {
        if (success) {
          axios.post('/process/module/add', dataObj).then(response => {
            if (response.status === 200) {
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeAwaitTillDateModal', returnObj)
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('DEBTIA_PROCESS_MODULE_ADDED_SUCCESS'),
                },
              })
            }
          }).catch(e => {
            const errorMsg = Array.isArray(e.response.data.message) ? e.response.data.message[0] : e.response.data.message
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: errorMsg,
              },
            })
          })
        }
      })
    },
  },
}
</script>
